module.exports = __webpack_public_path__ + "img/icon_map_3_off_110.daf357fb.png";